export default "<svg viewBox=\"0 0 30 20\" xmlns=\"http://www.w3.org/2000/svg\"><defs/><rect width=\"100%\" height=\"100%\" style=\"fill:#f4f4f4\"/></svg>";